var _a;
import { Mesh, MeshBasicMaterial, SphereGeometry, Color, CylinderGeometry } from "three";
import { mainScene } from "@modules/rendering/mainScene";
const DEBUG_DEFAULT_COLOR = "red";
const DEBUG_CYLINDER_RADIUS = 0.0125;
export class ScriptDebug {
}
_a = ScriptDebug;
ScriptDebug.debugSphereMap = new Map();
ScriptDebug.debugLineMap = new Map();
ScriptDebug.setDebugSphere = (name, position, props) => {
    var _b, _c, _d;
    let sphere = _a.debugSphereMap.get(name);
    if (sphere === undefined) {
        sphere = new Mesh(new SphereGeometry(1), new MeshBasicMaterial({ color: (_b = props === null || props === void 0 ? void 0 : props.color) !== null && _b !== void 0 ? _b : DEBUG_DEFAULT_COLOR }));
        _a.debugSphereMap.set(name, sphere);
        mainScene.add(sphere);
    }
    sphere.position.copy(position);
    sphere.scale.setScalar((_c = props === null || props === void 0 ? void 0 : props.size) !== null && _c !== void 0 ? _c : 1);
    sphere.material.color = new Color((_d = props === null || props === void 0 ? void 0 : props.color) !== null && _d !== void 0 ? _d : DEBUG_DEFAULT_COLOR);
};
ScriptDebug.removeDebugSphere = (name) => {
    const sphere = _a.debugSphereMap.get(name);
    if (sphere === undefined)
        return;
    _a.debugSphereMap.delete(name);
    mainScene.remove(sphere);
    sphere.material.dispose();
};
ScriptDebug.setDebugLine = (name, position, orientation, props) => {
    var _b, _c, _d, _e;
    let line = _a.debugLineMap.get(name);
    if (line === undefined) {
        const geometry = new CylinderGeometry(1, 1, 1);
        geometry.translate(0, 0.5, 0);
        line = new Mesh(geometry, new MeshBasicMaterial({ color: (_b = props === null || props === void 0 ? void 0 : props.color) !== null && _b !== void 0 ? _b : DEBUG_DEFAULT_COLOR }));
        _a.debugLineMap.set(name, line);
        mainScene.add(line);
    }
    const r = (_c = props === null || props === void 0 ? void 0 : props.radius) !== null && _c !== void 0 ? _c : DEBUG_CYLINDER_RADIUS;
    const len = (_d = props === null || props === void 0 ? void 0 : props.size) !== null && _d !== void 0 ? _d : 1;
    line.position.copy(position);
    line.quaternion.copy(orientation);
    line.scale.set(r, len, r);
    line.material.color = new Color((_e = props === null || props === void 0 ? void 0 : props.color) !== null && _e !== void 0 ? _e : DEBUG_DEFAULT_COLOR);
};
ScriptDebug.removeDebugLine = (name) => {
    const line = _a.debugLineMap.get(name);
    if (line === undefined)
        return;
    _a.debugLineMap.delete(name);
    mainScene.remove(line);
    line.material.dispose();
};
